export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9167.f7916ad0.jpg";